import type { EventSeverity, ServiceState } from "./types";

export function clamp(value: number, min = 0, max = 100) {
  return Math.max(min, Math.min(max, value));
}

export function formatBytes(bytes: number) {
  if (!Number.isFinite(bytes)) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let index = 0;
  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }
  return `${value.toFixed(value >= 10 || index === 0 ? 0 : 1)} ${units[index]}`;
}

export function formatUptime(seconds: number) {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

export function formatTime(value: string) {
  return new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }).format(new Date(value));
}

export function serviceRank(status: ServiceState) {
  if (status === "down") return 0;
  if (status === "warn") return 1;
  return 2;
}

export function statusLabel(status: ServiceState) {
  if (status === "ok") return "Online";
  if (status === "warn") return "Degraded";
  return "Down";
}

export function severityLabel(severity: EventSeverity) {
  if (severity === "critical") return "Critical";
  if (severity === "warn") return "Warn";
  return "Info";
}

export function percentTone(value: number | null | undefined) {
  if (value == null) return "muted";
  if (value >= 85) return "critical";
  if (value >= 70) return "warn";
  return "good";
}
